import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import api from "../../api";

Vue.use(Vuex);

export default new Vuex.Store({
  token: "",
  state: {
    user: {
      username: "",
      jwt: ""
    },
    layers: [],
    grid: [],
    currentLayer: {},
    uploadRes: false,
    displayActs: false,
    showButtons: false
  },
  mutations: {
    login(state, data) {
      state.user = data;
    },
    logout(state) {
      state.user.jwt = "";
    },
    layers(state, data) {
      state.layers = data;
    },
    grid(state, data) {
      state.grid = data;
    },
    currentLayer(state, data) {
      state.currentLayer = data;
    },
    showButtons(state, data) {
      state.showButtons = data;
    },
    uploadRes(state, data) {
      state.uploadRes = data;
    }
  },
  actions: {
    async login({ commit }, data) {
      const res = await api.auth.login(data);
      if (res.success) {
        sessionStorage.token = JSON.stringify(res.res.access_token);
        sessionStorage.user = JSON.stringify(data);
        this.token = res.res.access_token
        commit("login", res.res);
      }
      return res;
    },

    logout({ commit }) {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("token");
      commit("logout");
      window.location.reload()
    },
    async private({ dispatch }, data) {
      const res = await api.layers.private(data);
      if (res.success) dispatch('getLayers');
    },
    async notPrivate({ dispatch }, data) {
      const res = await api.layers.not_private(data);
      if (res.success) dispatch('getLayers');
    },

    async getLayersByStatus({ commit }) {
      let bearerToken = ""
      if(sessionStorage.token) {
        bearerToken = JSON.parse(sessionStorage.token)
      } else {
        bearerToken = this.token
      }
      try {
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v1/images?cv_state=DONE`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`
          }
        });
        const private_images = res.data;

        const response = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v1/images?cv_state=DONE`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`
          }
        });

        const images = private_images
        
        
        // filter layers by created date & add "selected" flag
        if (images) {
          images.forEach(element => {
            element.selected = false;
          });
          const groups = images.reduce((groups, image) => {
            const date = image.imaging_date.split('T')[0];
            if (!groups[date]) {
              groups[date] = [];
            }
            groups[date].push(image);
            return groups;
          }, {});
          const imagesByDate = Object.keys(groups).map((date) => {
            return {
              date,
              image: groups[date]
            };
          });
          imagesByDate.forEach(element => {
            element.visible = false;
          });
          const layers = imagesByDate
          console.log(layers)

          commit('layers', layers);
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getLayers({ commit }) {
      let bearerToken = ""
      if(sessionStorage.token) {
        bearerToken = JSON.parse(sessionStorage.token)
      } else {
        bearerToken = this.token
      }
      
      try {
        const response = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v1/images?cv_state=PENDING`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`
          }
        });
        const images = response.data;

        // filter layers by created date & add "slected" flag
        if (images) {
          function sortByProperty (property) {
            return function (a, b) {
              if (a[property] > b[property]) {
                console.log(a[property])
                return 1
              } else if (a[property] < b[property]) {
                console.log(a[property])
                return -1
              }
              console.log(a[property])
              return 0
            }
          }
          images.forEach(element => {
            element.selected = false;
          });
          const groups = images.reduce((groups, image) => {
            const date = image.imaging_date.split('T')[0];
            if (!groups[date]) {
              groups[date] = [];
            }
            groups[date].push(image);
            return groups;
          }, {});
          const imagesByDate = Object.keys(groups).map((date) => {
            return {
              date,
              image: groups[date]
            };
          });
          
          imagesByDate.forEach(element => {
            element.visible = false;
            element.selected = false;
          });
          const layers = imagesByDate
          commit('layers', layers.sort(sortByProperty("date")));
        }
      } catch (error) {
        console.error(error);
      }
      
    },

    async getGrid({commit}, data, conceal) {
      try {
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v1/images/${data}/intersected_secret_zones`)
        const grid = res.data
        console.log("getGrid in index!!!")
        commit ('grid', grid)
      } catch (error) {
        console.log("smth went wrong!", error)
      }
    },

    async setCurrentLayer({commit}, data) {
      try {
        const currentLayer = data
        commit ('currentLayer', currentLayer)
      } catch (error) {
        console.log(error)
      }
    },

    uploadShp({ dispatch }, data){

      const formData = new FormData()
      Array
        .from(Array(data.length).keys())
        .map(x => {
          formData.append('zip', data[x]);
        });

      axios({
        method: 'post',
        url: `${process.env.VUE_APP_BASE_URL}/api/v1/images/zip`,
        data: formData,
        headers: {
          'Authorization': `Bearer ${JSON.parse(sessionStorage.token)}`,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(function (response) {
        if (response.data.success) {
          dispatch('getLayers');
          this.eventBus.$emit("layerClicked", {});
          // return {success: true}
        }
      })
      .catch(function (error) {
          console.log(error);
      });
    },
    
    async downloadAct() {
      axios({
        url: `${process.env.VUE_APP_BASE_URL}/api/v1/acts`,
        method: 'GET',
        headers: {
              'Authorization': `Bearer ${JSON.parse(sessionStorage.token)}`
            },
        responseType: 'blob', // important
      }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'file.txt');
          document.body.appendChild(link);
          link.click();
      }).catch(function (error) {
        console.log(error)
      });
    }
    
    
  },
  modules: {},
  getters: {
    isAuthenticated: function (state) {
      if(sessionStorage.token) {
        state.user.jwt = JSON.parse(sessionStorage.token)
      } else {
        console.log("smth is wrong")
        state.user.jwt = ""
      }
      return !!state.user.jwt
    },
    // isAuthenticated: state => !!state.user.jwt,
    user: state => state.user.jwt,
    layers: state => state.layers,
    grid: state => state.grid,
    currentLayer: state => state.currentLayer,
    showButtons: state => state.showButtons,
    uploadRes: state => state.uploadRes
  },
  inject: ["eventBus"]
});
